import { createSlice } from "@reduxjs/toolkit";
import { CAMPAIGN_VIEW_TAB, FIRST_PAGE } from "./constants";
const initialState = {
  isLoading: false,
  data: [],
  error: null,
  changeStatus: {
    isLoading: false,
    data: {},
    error: null,
  },
  count: [],
  countError: null,
  viewTab: {[CAMPAIGN_VIEW_TAB.all]: FIRST_PAGE},
};

const viewCampaignsSlice = createSlice({
  name: "ViewCampaigns",
  initialState,
  reducers: {
    getCampaignsCount: (state, action) => {},
    getCampaignsCountSuccess: (state, action) => {
      state.count = action.payload;
    },
    getCampaignsCountError: (state, action) => {
      state.countError = action.payload;
    },
    getCampaignList: (state, action) => {
      state.isLoading = true;
      state.error = null;
      state.data = [];
    },
    getCampaignListSuccess: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    getCampaignListError: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    changeStatus: (state, action) => {
      state.changeStatus.isLoading = true;
    },
    changeStatusSuccess: (state, action) => {
      state.changeStatus.isLoading = false;
      state.changeStatus.data = action.payload.data;
      const newList = [...state.data];
      newList[action.payload.index] = action.payload.data;
      state.data = newList;
    },
    changeStatusError: (state, action) => {
      state.changeStatus.isLoading = false;
      state.changeStatus.error = action.payload;
    },
    updateViewTab: (state, action) => {
      const {type, page} = action.payload
      state.viewTab = {[type] : page};
    },
  },
});

export const {
  getCampaignList,
  getCampaignListSuccess,
  getCampaignListError,
  changeStatus,
  changeStatusSuccess,
  changeStatusError,
  getCampaignsCount,
  getCampaignsCountSuccess,
  getCampaignsCountError,
  updateViewTab,
} = viewCampaignsSlice.actions;

export default viewCampaignsSlice.reducer;
